import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'

import 'react-toastify/dist/ReactToastify.css'

import "./design/css/app.css"
import "./design/css/organization.css"
import "./design/css/members.css"
import "./design/css/review.css"
import "./design/css/button.css"
import "./design/css/modal.css"

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)

reportWebVitals()
